// main component
import { useContext, useEffect, useState } from 'react';
import { useForm, useFieldArray, SubmitHandler, Controller} from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import StateContext from '../stateContext';
import axios from 'axios';

export function Subscription() {

  // get state context
  const { createNotification, applicationStati, userInfo, setUserInfo} = useContext(StateContext);

  const { userid, sessionID } = useParams();
  const [ userDetails, setUserDetails ] = useState({});
  const [ subResponMes, setSubResponMes ] = useState(undefined);

  // make api call to confirm subscription 
  useEffect(() => {

    if (userid instanceof String) {
      return;
    }

    if (sessionID instanceof String) {
      return;
    }

    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/subscription/confirmation',
      {
        "userid": userid,
        "sessionID": sessionID,
        "email": userInfo.email,
        "jwt": userInfo.jwt,
      }
    ).then((response) => {
      if (response.status == 200 ) {
        if(response.data.success == true && response.data.results > 0) {
          // update account type
          var updatedAccountType = "basic"
          if (response.data.result.account_type == "premium") {
            updatedAccountType = "premium"
          }

          setUserInfo(
            {
              ...userInfo,
              account_type: updatedAccountType
            }
          )

          // update user details with 
          getUserDetails();
        } else {
          // prompt error 
          setSubResponMes(1);
        }
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Subscription verification error!",
        })
      }
    })
  }, [userid, sessionID]);

  async function getUserDetails() {
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/account/get',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
      }
    ).then((response) => {
      if (response.status == 200 && response.data.success == true && response.data.results > 0) {
        setUserDetails(response.data.result);
      } else {
        createNotification({
          "status": "error",
          "msg": "Error fetching user profile",
        })
      }
    });
  }

  return (
    <main style={{paddingBottom: "80px", display: 'flex', flexDirection: "column", alignItems: "center", maxWidth: "650px", margin: "auto"}}>
      { subResponMes != undefined ?
        <>
          <h2>Looks like there was an error with your session</h2>
          <span>Log out and back in to apply changes. If the issue persist, reach out to support.</span>
        </>
        :
        <>
          <span style={{textAlign: "center"}}>You account details are used to generate resumes initially. Lets check you account details.</span>
          {
            !userDetails.name || typeof userDetails.name.valueOf() !== 'string' || userDetails.name.trim().length === 0 ?
            <DetailCheck detailType="warning" msg="Missing Name" navLink="/profile/userDetails"/>
            :
            <DetailCheck detailType="success" msg="Name is valid" navLink="/profile/userDetails"/>
          }
          {
            !userDetails.email || typeof userDetails.email.valueOf() !== 'string' || userDetails.email.trim().length === 0 ?
            <DetailCheck detailType="warning" msg="Missing Email" navLink="/profile/userDetails"/>
            :
            <DetailCheck detailType="success" msg="Email is valid" navLink="/profile/userDetails"/>
          }
          {
            !userDetails.location || typeof userDetails.location.valueOf() !== 'string' || userDetails.location.trim().length === 0 ?
            <DetailCheck detailType="warning" msg="Missing location details" navLink="/profile/userDetails"/>
            :
            <DetailCheck detailType="success" msg="Location details are valid" navLink="/profile/userDetails"/>
          }
          {
            !userDetails.experiences || typeof userDetails.experiences.valueOf() !== 'object' || userDetails.experiences.length <= 0 ?
            <DetailCheck detailType="warning" msg="Missing experience details" navLink="/profile/workexperience"/>
            :
            <DetailCheck detailType="success" msg="Experience details are valid" navLink="/profile/workexperience"/>
          }
          {
            !userDetails.skills || typeof userDetails.skills.valueOf() !== 'object' || userDetails.skills.length <= 0 ?
            <DetailCheck detailType="warning" msg="Missing skill details" navLink="/profile/skills"/>
            :
            <DetailCheck detailType="success" msg="Skill details are valid" navLink="/profile/skills"/>
          }
          {
            !userDetails.topic_excludes || typeof userDetails.topic_excludes.valueOf() !== 'object' || userDetails.topic_excludes.length <= 0 ?
            <DetailCheck detailType="warning" msg="Missing topic exclude details" navLink="/profile/topicexcludes"/>
            :
            <DetailCheck detailType="success" msg="Topic exclude details are valid" navLink="/profile/topicexcludes"/>
          }
          {
            !userDetails.desired_roles || typeof userDetails.desired_roles.valueOf() !== 'object' || userDetails.desired_roles.length <= 0 ?
            <DetailCheck detailType="warning" msg="Missing desired role details" navLink="/profile/desiredroles"/>
            :
            <DetailCheck detailType="success" msg="Desired role details are valid" navLink="/profile/desiredroles"/>
          }
          <h4>Generate Resumes from</h4>
          <Link 
            style={{backgroundColor: "#1e4ad7", color: "white", fontSize: "14px", padding: "5px 10px", borderRadius: "5px", fontWeight: "bold"}}
            to="/home"
          >
            Job listings
          </Link>
          <div style={{display: 'flex', flexDirection: "row", width: "100%"}}><hr style={{width: "40%"}}/><span>or</span><hr style={{width: "40%"}}/></div>
          <Link
            style={{backgroundColor: "#1e4ad7", color: "white", fontSize: "14px", padding: "5px 10px", borderRadius: "5px", fontWeight: "bold"}}
            to="/applications/all"
          >
            Your Job Applications
          </Link>
        </>
      }

    </main>
  )
}

export function DetailCheck({detailType, msg, navLink}) {

  return ( 
    <article
      style={
        detailType == "warning" ?
        { width: "calc(100% - 20px)", backgroundColor: '#fcedd8', border: "2px solid #FFA231",
        padding: "10px", borderRadius: "5px", position: "relative" }
        :
        { width: "calc(100% - 20px)", backgroundColor: '#edf6ee', border: "2px solid #62b768",
        padding: "10px", borderRadius: "5px", position: "relative" }
      }
    >
      <span
        style={{
          display: "flex", flexDirection: "row", alignItems: "center", gap: "5px"
        }}
      >
        { detailType == "warning" ? 
        <svg width="20px" height="20px" style={{color: "#FFA231"}} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        : undefined }
        {msg}
      </span>
      <p style={
        detailType == "warning" ?
        {color: "#FFA231", marginBottom: "0px", marginTop: "5px", fontSize: "12px"}
        :
        {color: "#62b768", marginBottom: "0px", marginTop: "5px", fontSize: "12px"}
        }
      >
      {"(Used during the resume generation process)"}
      </p>
      <button
        style={{
          backgroundColor: "white", padding: "5px", borderRadius: "5px", fontSize: "12px",
          position: "absolute", top: "8px", right: "8px"
        }}
        onClick={() => {window.open(navLink, "_blank")}}
      >Update</button>
    </article>
  )
}